import React from 'react'
import Footer from '../components/footerComponent/footer'
import EditOldLesson from '../components/teacherComponent/editOldLessonComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function EditOldLessonPage() {
    return (
        <Layout>
            <Header/>
            <EditOldLesson/>
            <Footer/>
        </Layout>
    );
};